import {observer} from "mobx-react";
import React from "react";
import {FormProps, lovLabel, lovValue} from "../../core/form/formUtils";
import {Validate} from "../../core/form/validate";
import {MdTextField} from "../../core/components/fields/fields";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "../../core/form/closedForm";
import {DefinitionType} from "../../core/form/form";
import {createForm, fieldStyles} from "../../core/form/createForm";
import {EntityNumberGenGroup} from "../domain/entityNumberGenDomain";
import {BlockComp} from "../../core/components/blockComp/blockComp";
import StyledSelect from "../../core/components/fields/styledSelect";
import {optionsSearch} from "../../core/common/service/commonDataService";
import {PARTYROLE} from "../../party/partyDomain";
import {INVOICE_TYPE} from "../domain/invoiceDomain";
import {HasLength} from "../../core/form/rules";
import mdEntityService from "core/metamodel/mdEntityService";

@observer
class EntityNumberGenGroupForm extends React.Component<FormProps<EntityNumberGenGroup, EntityNumberGenGroup>, undefined> {


  render() {

    let {dataObject, rootObject, entities, entity} = this.props;
    let fields = dataObject.getFormFields(EntityNumberGenGroupFormDefinition.formName);
    let {name, party, profitCenterIds, invoiceTypeIds} = fields;

    const openContent: JSX.Element = (
      <form style={{marginTop: 10}}>
        <BlockComp>
          <div className="row">

            <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...fieldStyles.small.styledSelect} name="testEntity" value={{value: dataObject.entityName, label: lovLabel(entities.get("MdEntity").getLovItem(dataObject.entityName))}}  floatingLabelText="Select Entity Type"
                          options={entities.get("MdEntity").lovItems} fullWidth={true}
                          onChange={this.onChangeEntity} clearable={false} />
            </div>

            <div className="fx col-xs-12 col-sm-4">
              <MdTextField {...name.props} />
              <Validate field={name} value={name.props.value}>
                <HasLength max={30}/>
              </Validate>
            </div>
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect  {...party.props} async={true}
                             loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.CUSTOMER_ROLE]})}
                             clearable={true}/>
              <Validate field={party} value={party.props.value}/>
            </div>
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...profitCenterIds.props} multi floatingLabelStyle={{top: 15}}/>
              <Validate field={profitCenterIds} value={profitCenterIds.props.value}/>
            </div>
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...invoiceTypeIds.props} multi floatingLabelStyle={{top: 15}}/>
              <Validate field={invoiceTypeIds} value={invoiceTypeIds.props.value}/>
            </div>
          </div>
        </BlockComp>
      </form>
    );

    return openContent;
  }

  onChangeEntity = (entityLov) => {
    console.log('onChangeEntity');
    const {dataObject, rootObject} = this.props;
    dataObject.entityName = lovValue(entityLov);
    rootObject.$dirty = true;
  };

}


const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<EntityNumberGenGroup>) => (
  <div style={{width: '100%'}}>
    <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
      <ClosedFormField label={fields.entityName.textLabel} value={dataObject.entityName}/>
      <ClosedFormField label={fields.name.textLabel} value={dataObject.name}/>
      <ClosedFormField label={fields.party.textLabel} value={dataObject.party}
                       linkProps={{to: 'partyDetail', params: {id: lovValue(dataObject.party)}}}/>
      <ClosedFormField label={fields.invoiceTypeIds.textLabel} value={dataObject.invoiceTypeIds}/>
      <ClosedFormField label={fields.profitCenterIds.textLabel} value={dataObject.profitCenterIds}/>
    </ClosedFormBlock>
  </div>
);


export const EntityNumberGenGroupFormDefinition: DefinitionType = {
  formName: 'EntityNumberGenGroupForm',
  fields: [{
    name: 'entityName',
    validators: ['IsRequired']
  }, {
    name: 'name',
    validators: ['IsRequired']
  }, {
    name: 'party'
  }, {
    name: 'profitCenterIds',
    omitNullOption: true
  }, {
    name: 'invoiceTypeIds',
    omitNullOption: true
  },]
};

export default createForm(EntityNumberGenGroupFormDefinition, ClosedContent)(EntityNumberGenGroupForm);



// WEBPACK FOOTER //
// ./src/invoice/component/entityNumberGenGroupForm.tsx